import React, {useEffect, useState} from "react";
import {Col, Row, Card} from "antd";
import {FormattedMessage} from "react-intl";
import api from "@api/tracker-policy";
import VideoContentsReportSearch from "@components/tracker-policies/Report/Search";
import ReportsChart from "@components/tracker-policies/Report/Chart";



function TrackerReportPage(props) {
  const {id} = props.match.params
  const [state, setState] = useState({
    isFetched: false,
    params: {},
    data : []
  });
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (params={}) => {
    api.getItemClickReport({
        params : { id, ...params }
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          params,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <VideoContentsReportSearch search={fetch}/>
        </Card>
      </Col>
      <Col span={24}>
        {state.data.length > 0 && <ReportsChart interval={state.params.interval} data={state.data}/>}
      </Col>
    </Row>
  )
}

export default TrackerReportPage;

